module.exports = __webpack_public_path__ + "media/images/pharmacies/deadstock-1b22c514a916e5fc46eca813c3a09931.png";